<template>
  <div class="status">
    <div class="table">
      <ul class="table-ul table-first">
        <li class="table-ul-n">姓名</li>
        <li>理赔单状态</li>
      </ul>
      <ul
        class="table-ul"
        @click="toEdit()"
        :class="{
          edit: status == 52,
        }"
        v-for="(item, index) in list"
        :key="index"
      >
        <li class="table-ul-n">{{ item.col_1 }}</li>
        <li>
          <div>{{ item.col_2 }}</div>
          <div class="table-ul-f" v-if="status == 51 || status == 34">
            <p v-if="status == 51">很抱歉，您提交的资料不符合理赔条件</p>
            <p>如有疑问，可拨打{{ insuranceName }}座机：</p>
            <p>{{ phone }}</p>
            <p>工作时间：{{insuranceWorkTime1}}</p>
            <p>{{insuranceWorkTime2}}</p>
            <p>{{insuranceWorkTime3}}</p>
          </div>
          <div class="table-ul-g" v-if="status == 52">
            很抱歉，您提交的材料不完全，请按要求重新上传
          </div>
        </li>
      </ul>
      <div v-if="statusDesc" class="status-desc">
        <ul class="table-ul table-first">
          <li>补充说明</li>
        </ul>
        <div class="status-desc-content">{{ statusDesc }}</div>
      </div>
    </div>
    <div v-if="status == '31'" class="operate">
      <van-button @click="btnFn('no')" type="info" class="btn-ccc"
        >有异议</van-button
      >
      <van-button @click="btnFn('yes')" class="btn-margin" type="info"
        >确认</van-button
      >
    </div>
    <van-button
      v-if="status == '52'"
      @click="toEdit()"
      type="info"
      class="btn-edit"
      >编辑我的理赔信息</van-button
    >
    <Dialog
      :visible="isShow"
      :type="dialogType"
      :phone="phone"
      :insuranceName="insuranceName"
      :insuranceWorkTime1="insuranceWorkTime1"
      :insuranceWorkTime2="insuranceWorkTime2"
      :insuranceWorkTime3="insuranceWorkTime3"
      :payMoneyDays="payMoneyDays"
      :isGuidToYou="isGuidToYou"
      @dialog="DialogCall"
    ></Dialog>
  </div>
</template>
<script>
import Dialog from "./components/dialog.vue";
export default {
  name: "MineStatus",
  components: { Dialog },
  data() {
    return {
      idStr: this.$route.params.idStr,
      list: [],
      canEdit: null,
      status: null,
      t: "",
      amount: "",
      isShow: false,
      dialogType: "", // yes-已确认 no-有异议
      phone: "",
      statusDesc: "",
      insuranceName: "",
      insuranceWorkTime1:"",
      insuranceWorkTime2:"",
      insuranceWorkTime3:"",
      payMoneyDays:"",
      isGuidToYou:""
    };
  },
  created() {
    this.getClaimInfo();
  },
  methods: {
    async getClaimInfo() {
      let claimResult = (
        await this.$api.user.queryClaim({
          idStr: this.idStr,
        })
      ).data;
      this.list = claimResult.list;
      this.canEdit = claimResult.canEdit;
      this.serNo = claimResult.serNo;
      this.status = claimResult.status;
      this.t = claimResult.t;
      this.phone = claimResult.phone;
      this.statusDesc = claimResult.statusDesc;
      this.insuranceName = claimResult.name;
      this.insuranceWorkTime1 = claimResult.workTime[0];
      this.insuranceWorkTime2 = claimResult.workTime[1];
      this.insuranceWorkTime3 = claimResult.workTime[2];
      this.payMoneyDays = claimResult.payMoneyDays;
      this.isGuidToYou = claimResult.isGuidToYou;
    },
    btnFn(type) {
      this.isShow = true;
      this.dialogType = type;
    },
    async DialogCall() {
      this.isShow = false;
      // 确认金额
      await this.$api.user.confirmClaimMoney({
        serNo: this.serNo,
        agree: this.dialogType,
      });
      this.getClaimInfo();
    },
    toEdit() {
      if (this.status !== 52) return;

      let path = `/claimMaterial/uploadBasic/${this.t}?serNo=${this.serNo}`;

      this.$router.push(path);
    },
  },
};
</script>
<style scoped lang="less">
.status {
  .table {
    width: 90%;
    margin: 0 auto;
    padding-top: 40px;
    .table-ul {
      display: flex;
      border-right: 1px solid #f1a705;
      box-sizing: border-box;

      &.edit {
        color: dodgerblue;
      }

      li {
        flex: 1;
        text-align: center;
        padding: 4px 0;
        border-left: 1px solid #f1a705;
        border-bottom: 1px solid #f1a705;

        &.table-ul-n {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 35%;
          flex: none;
        }

        .table-ul-f {
          margin-top: 10px;
          font-size: 12px;
          font-weight: 600;
        }
        .table-ul-g {
          margin-top: 10px;
          font-size: 12px;
          color: red;
        }
      }
    }

    .status-desc {
      margin-top: 60px;
    }
    .status-desc-content {
      border: 1px solid #f1a705;
      border-top: 0;
      padding: 20px;
      line-height: 20px;
    }
    .table-first {
      background: #f1a705;
      color: #fff;
    }
  }

  .operate {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    .van-button {
      flex: 1;

      &:last-child {
        margin-left: 2px;
      }
    }
    .btn-ccc {
      background: #ccc;
      border: 1px solid #ccc;
    }
  }

  .btn-edit {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>
